<template>
  <div id="app">

    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    window.document.title = "三才鲲鹏驾驶员考试系统";
  }


}
</script>

<style lang="less">
@import './assets/css/allStyle.css';

html {
  font-size: 13.3333vw;
}

body {
  font-size: .16rem;
}
@media (min-width: 2000px) {
  body {
    font-size: .14rem;
  }
}

#app {

  width: 100%;
  height: 100vh;

  // color: #fff !important;
  .examinee-text {
    color: #fff !important;
  }
}

#app>div {
  // background-color: #000a3b;
  height: 100vh !important;
}

video {
  display: none;
}
</style>
